    jQuery(document).ready(function ($) {

        enablePardotTracking(); ////Form tracking

        // Cookies: get & set
        var $alertBox = $('#cookie-policy'),
            cookieId = $alertBox.data("cookie-id"),
            cookieVal = $alertBox.data("cookie-value"),
            cookieExp = $alertBox.data("cookie-expiration");

        // if cookie-id-xxxxx does not exist, render alert box
        if (!Cookies.get(cookieId)) {
            $alertBox.removeClass('d-none');
        }

        var $optIn = $('#cookieOptin');

        // if verisk_Consent does not exist and the user is non-EU, drop the verisk_Consent cookie
        if (!Cookies.get("verisk_Consent") && $optIn.length === 0) {
            Cookies.set("verisk_Consent", cookieVal, { expires: cookieExp });
        }

        $('#acceptCookies').off('click.accept').on('click.accept', function (e) {
            e.preventDefault();
            $alertBox.addClass('d-none');
            Cookies.set(cookieId, cookieVal, { expires: cookieExp }); // set cookie based on data attributes
            if ($optIn !== null && $optIn.prop('checked') === true) {
                Cookies.set("verisk_Consent", cookieVal, { expires: cookieExp }); // set verisk_Consent cookie if EU user opts in
                ////location.reload();
            }
        });

        // GDPR: if no consent is given, reset EPi_NumberOfVisits to 1
        if (!Cookies.get("verisk_Consent") && Cookies.get(cookieId)) {
            Cookies.set("EPi_NumberOfVisits", 1);
        }

        // if consent is given:
        if (Cookies.get("verisk_Consent")) {
            ////(nothing to enable)
            ////enablePardot();            
        }

        ////(fired through GTM)
        ////function enablePardot() {
        ////    piAId = '457202';
        ////    piCId = '48519';
        ////    (function () {
        ////        function async_load() {
        ////            var s = document.createElement('script'); s.type = 'text/javascript';
        ////            s.src = ('https:' === document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
        ////            var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
        ////        }
        ////        if (window.attachEvent) { window.attachEvent('onload', async_load); }
        ////        else { window.addEventListener('load', async_load, false); }  
        ////    })();
        ////    enablePardotTracking();
        ////}

        function enablePardotTracking() {
                (function () {
                    if (!document.querySelector('#embedform iframe')) return;
                    //respond to events                    
                    window.addEventListener('message', function (e) {
                        //console.log('adding eventlistener ' + e);
                        //console.log('event origin ' + e.origin);
                        //console.log('event data ' + e.data);         
                        //console.log("Recieved event " + JSON.stringify(e));
                        //if (e.origin !== 'https://go.pardot.com' || (e.data !== 'Pardot form submission' && e.data !== 'Pardot form completion')) return;
                        if (e.origin === 'https://go.pardot.com' && (e.data === 'pardotFormSubmit')) {                        
                            //console.log('message received:  ' + e.data);
                            window.dataLayer = window.dataLayer || [];                        
                            //console.log('before datalayer push');
                            //window.dataLayer.push({
                            //    'event': e.data === 'Pardot form submission' ? 'pardotFormSubmitButtonClick' : 'pardotFormSubmit'
                            //});
                            window.dataLayer.push({
                                'event': 'formSubmit'
                            });
                        }
                    });
            })();
        }        

    }); 